import { render } from "./currency-converter-settings.vue?vue&type=template&id=52bfddca&ts=true"
import script from "./currency-converter-settings.ts?vue&type=script&lang=ts"
export * from "./currency-converter-settings.ts?vue&type=script&lang=ts"

import "./currency-converter-settings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__